import { useMemo, useCallback, useState } from 'react';
import { BaseNewAndDetail, getDarkThemeClass, defErrProps } from '../../utility';
import { useTheme } from '@emotion/react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import _UnitTab from './_UnitTab';
import { UnitBreadCrumbs } from '../../utility/BreadcrumbLinks';

export default function Unit(props) {
  const [values, setValues] = useState({});

  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab');

  const theme = useTheme();
  const { unit } = useParams();

  const currentTab = unit || 'Unit';
  const currDarkThemeClass = useMemo(() => getDarkThemeClass(theme), [theme?.palette?.themeMode]);

  const baseEntityName = 'Units';
  const unitTagKey = 'unit';

  const tabEntityMap = [{ key: unitTagKey, label: 'Units', defaultForDetail: true, validForNew: false }];

  const navigate = useNavigate();

  const breadcrumbsProps = {
    currLink: currentTab,
    currDarkThemeClass,
    navigate,
  };
  const breadcrumbs = <UnitBreadCrumbs {...breadcrumbsProps} />;

  const handleErrorWithFeedback = feedbackCX => (handleSetValues, errPropsFn) => err => {
    handleSetValues('error', true);
    handleSetValues('loading', true);
    const errProps = errPropsFn?.(err) ?? defErrProps;

    feedbackCX?.setContextValue?.(true, errProps);
  };

  const handleSetLoading = prop => value => handleSetValues('loading', { ...values?.loading, [prop]: value });

  const handleEntityEntryCreateRes = prop => res => {
    handleSetLoading(prop)(false);

    const { data } = res;
    const newState = data?.length > 0 ? [...values?.[prop], ...data] : [...values?.[prop], data];

    handleSetValues(prop, newState);

    return Promise.resolve({ success: true });
  };
  const handleEntityEntryModifyRes = prop => res => {
    const { data } = res;

    handleSetValues(
      prop,
      values?.[prop]?.map(e => (e.id === data.id ? data : e))
    );

    return Promise.resolve({ success: true });
  };
  const handleSetValues = useCallback((prop, value) => setValues(state => ({ ...state, [prop]: value })), [setValues]);

  const toDisable = () => {
    // different toDisable conditions based on tab
    switch (tab) {
      default:
        return true;
    }
  };

  const handleSave = () => {
    console.log('Everythting is upto date');
  };

  const getDefaultTabForEndpoint = () => tabEntityMap?.find(tab => tab?.defaultForDetail)?.key;

  const unitTagsprops = {
    currDarkThemeClass,
    strains: values?.strains,
    openStrainsPopup: values?.openStrainsPopup ?? false,
    addNew: values?.add ?? false,
    update: values?.update ?? false,
    handleErrorWithFeedback,
    handleEntityEntryCreateRes,
    handleEntityEntryModifyRes,
    handleSetValues,
  };

  const tabContentMap = {
    [unitTagKey]: <_UnitTab {...unitTagsprops} />,
  };
  const defShowSaveBtn = () => false;

  const baseProps = {
    baseEntityName,
    baseid: undefined,
    currDarkThemeClass,
    tabContentMap,
    tabEntityMap,
    breadcrumbs,
    createBaseEntityMsg: '',
    baseEndpointCheck: false,
    enablePopup: true,
    showSaveBtn: defShowSaveBtn,
    toDisable,
    handleSave,
    getDefaultTabForEndpoint,
  };
  return <BaseNewAndDetail {...baseProps} />;
}
